<a *ngIf="isClickable === true" download [href]="metaFileLink.url" target="_blank">
  <div class="image" [style.background-image]="'url(' + thumbnailImageUrl + ')'"></div>
</a>
<a *ngIf="isClickable === false">
  <div class="image" [style.background-image]="'url(' + thumbnailImageUrl + ')'"></div>
</a>
